import { TerminalForm } from '../primitives';

export const ContactTerminal = () => {
  return <TerminalForm />;
};
